import { __extends } from "tslib";
import { RendererBase } from './RendererBase';
/**
 * The DistanceRenderer class renders 32-bit depth information encoded as RGBA
 *
 * @class away.render.DistanceRenderer
 */
var DistanceRenderer = /** @class */ (function (_super) {
    __extends(DistanceRenderer, _super);
    /**
     * Creates a new DistanceRenderer object.
     * @param renderBlended Indicates whether semi-transparent objects should be rendered.
     * @param distanceBased Indicates whether the written depth value is distance-based or projected depth-based
     */
    function DistanceRenderer(partition, pool) {
        return _super.call(this, partition, pool) || this;
    }
    /**
     *
     */
    DistanceRenderer.prototype.enterNode = function (node) {
        var enter = node._collectionMark != RendererBase._collectionMark && node.isCastingShadow();
        if (!enter) {
            node._collectionMark = RendererBase._collectionMark;
            return false;
        }
        return _super.prototype.enterNode.call(this, node);
    };
    DistanceRenderer.registerMaterial = function (renderMaterialClass, materialClass) {
        DistanceRenderer.materialClassPool[materialClass.assetType] = renderMaterialClass;
    };
    DistanceRenderer.materialClassPool = {};
    DistanceRenderer.renderGroupPool = {};
    DistanceRenderer.defaultBackground = 0x0;
    return DistanceRenderer;
}(RendererBase));
export { DistanceRenderer };
